import { React, useState, useRef } from "react";
import ContactPopup from "../ContactPopup";
import { Helmet } from "react-helmet";
import "../ImportExport/ServicePages.css";
const ITRU = () => {
  

 const [openPopup, setOpenPopup] = useState(false);

    const contactRef = useRef(null);

    const scrollToContact = () => {
        contactRef.current?.scrollIntoView({ behavior: "smooth" });
    }

  return (
    <div className="service-page">

      {/* SEO */}
      <Helmet>
        <title>ITR-U Filing Service | Updated Income Tax Return India</title>
        <meta
          name="description"
          content="File your ITR-U (Updated Income Tax Return) easily. Correct missed income, errors, or late filings with expert assistance under Section 139(8A)."
        />
        <meta
          name="keywords"
          content="ITR-U filing, updated return India, income tax correction, Section 139(8A), late ITR filing"
        />
      </Helmet>

      {/* HERO */}
      <section className="service-hero">
        <h1>ITR-U Filing Service</h1>
        <p>Update your Income Tax Return easily under Section 139(8A)</p>
        <button className="hero-btn" onClick={scrollToContact}>
                        Get Started Today
                    </button>
      </section>

      {/* OVERVIEW */}
      <section className="service-section">
        <h2>Overview</h2>
        <p>
          ITR-U (Updated Income Tax Return) allows taxpayers to update previously 
          filed or missed returns under Section 139(8A) of the Income Tax Act, 1961.
        </p>
        <p>
          It helps you correct mistakes, report missed income, and stay compliant 
          with the latest tax regulations.
        </p>
      </section>

      {/* TIME LIMIT */}
      <section className="service-section">
        <h2>Latest Time Limit (Effective 1 April 2025)</h2>
        <div className="card">
          <strong>Up to 48 Months (4 Years)</strong> from the end of relevant Assessment Year
        </div>
        <p>
          Earlier limit was 24 months — now extended to 48 months for better compliance flexibility.
        </p>
      </section>

      {/* ADDITIONAL TAX */}
      <section className="service-section">
        <h2>Additional Tax Payable</h2>
        <div className="card">Within 12 months → 25% additional tax + interest</div>
        <div className="card">12 to 24 months → 50% additional tax + interest</div>
        <div className="card">24 to 36 months → 60% additional tax + interest</div>
        <div className="card">36 to 48 months → 70% additional tax + interest</div>
      </section>

      {/* WHO CAN FILE */}
      <section className="service-section">
        <h2>Who Can File ITR-U?</h2>
        <ul>
          <li>Individuals</li>
          <li>Freelancers & Professionals</li>
          <li>Business Owners</li>
          <li>Companies & Firms</li>
        </ul>

        <h3>Applicable When:</h3>
        <ul>
          <li>Income missed in previous return</li>
          <li>Wrong details filed</li>
          <li>ITR not filed earlier</li>
        </ul>
      </section>

      {/* NOT ALLOWED */}
      <section className="service-section">
        <h2>When ITR-U Cannot Be Filed</h2>
        <ul>
          <li>To claim refund</li>
          <li>To show loss</li>
          <li>To reduce tax liability</li>
          <li>If assessment/scrutiny is ongoing</li>
        </ul>
      </section>

      {/* SERVICES */}
      <section className="service-section">
        <h2>Our ITR-U Services Include</h2>
        <ul>
          <li>Eligibility check as per latest rules</li>
          <li>Re-computation of income</li>
          <li>Additional tax calculation</li>
          <li>Accurate ITR-U filing</li>
          <li>Correction of previous returns</li>
          <li>Notice handling support</li>
        </ul>
      </section>

      {/* IMPORTANCE */}
      <section className="service-section">
        <h2>Why ITR-U is Important?</h2>
        <ul>
          <li>✔ Avoid heavy penalties & notices</li>
          <li>✔ Correct past mistakes legally</li>
          <li>✔ Stay compliant with tax laws</li>
          <li>✔ Reduce future litigation risk</li>
        </ul>
      </section>

      {/* DOCUMENTS */}
      <section className="service-section">
        <h2>Documents Required</h2>
        <ul>
          <li>PAN & Aadhaar</li>
          <li>Previous ITR details</li>
          <li>Updated income information</li>
          <li>Bank statements</li>
          <li>Supporting documents</li>
        </ul>
      </section>

      {/* WHY CHOOSE US */}
      <section className="service-section">
        <h2>Why Choose Us?</h2>
        <ul>
          <li>✔ Updated with latest 2025 rules</li>
          <li>✔ Accurate tax calculations</li>
          <li>✔ End-to-end support</li>
          <li>✔ Quick & secure process</li>
          <li>✔ Expert professionals</li>
        </ul>
      </section>

      {/* CTA */}
      {/* <section className="service-cta">
        <h2>Missed Your ITR?</h2>
        <p>Update it easily within extended time limits.</p>
        <button>Get Started Now</button>
      </section> */}

          <div className="cta" ref={contactRef}>
              <h2>Missed Your ITR?</h2>
              <p>Update it easily within extended time limits.</p>
      
              <div className="cta-buttons">
                <button onClick={() => setOpenPopup(true)}>Get Started Now</button>
                <ContactPopup
                  isOpen={openPopup}
                  onClose={() => setOpenPopup(false)}
                />
      
                <button className="outline" onClick={() => window.location.href = "tel:9218103915"} >Free Consultation</button>
              </div>
            </div>

    </div>
  );
};

export default ITRU;